import "bijou/base";

(function ($) {
  $.fn.changeVal = function (v) {
    return this.val(v).trigger("change");
  };

  $.widget("bijou.addressFinder", $.bijou.base, {
    options: {
      lookupUrl: null,
      fetchUrl: null,
      state: "",
      form: null,
    },

    _create() {
      this.searchBlock = this.element.find(".search");
      this.searchField = this.searchBlock.find("input");
      this.searchButton = this.searchBlock.find("button");
      this.addressDropdown = this.searchBlock.find("select");

      this.addressFields = this.element.find(".fields input");

      this._on({
        "click .search button": function () {
          this.lookup();
        },

        "click .switch-to-manual": function (e) {
          e.preventDefault();
          this.setState("manual");
        },

        "click .switch-to-search": function (e) {
          e.preventDefault();
          this.setState("search");
        },
      });

      this.searchButton.prop("disabled", !this.searchField.val().trim());

      this._on(this.searchField, {
        input() {
          this.searchButton.prop("disabled", !this.searchField.val().trim());
        },
      });

      this._on(this.addressDropdown, {
        change() {
          if (this.addressDropdown[0].selectedIndex > 0) {
            this.fetch(this.addressDropdown.val());
          }
        },
      });

      this._on(this.options.form, {
        validate(e) {
          // When form is submitted with a valid postcode but no lookup
          if (
            this.searchField.is(":visible") &&
            this.options.state === "search" &&
            !this.searchBlock.hasClass("with-results")
          ) {
            this.searchField.rules("add", {
              not: this.searchField.val(),
            });
            this.searchField.valid();
            this.searchField.rules("remove", "not");
            this.searchButton.trigger("focus");
            e.preventDefault();
          }
        },
      });

      this.options.state = this.element.hasClass("state-search")
        ? "search"
        : "manual";
    },

    setState(state) {
      if (state === this.options.state) {
        return;
      }

      this.element.removeClass(`state-${this.options.state}`);
      this.options.state = state;
      this.element.addClass(`state-${this.options.state}`);

      if (this.options.state === "search") {
        this.searchBlock.removeClass("no-results");
        this._resetValidation(this.addressFields);
        this.addressFields.not("[readonly]").val("");

        if (this.searchBlock.hasClass("with-results")) {
          this.addressDropdown.trigger("focus");
        } else {
          this.searchField.trigger("focus");
        }
      }

      if (this.options.state === "manual") {
        this._resetValidation(this.searchField);
        this._resetValidation(this.addressDropdown);
        this.addressDropdown.val("");
        this.addressFields.first().trigger("focus");
      }
    },

    // TODO: move this functionality to smart form
    _resetValidation(inputs) {
      inputs.each(function () {
        $(this)
          .removeClass("error valid")
          .closest(".control-block")
          .removeClass("error valid")
          .find("span.error")
          .hide();
      });
    },

    // True only when jquery-validate has an initialised validator on the form.
    // `$.fn.valid` being defined is not enough (it's bundled on backoffice
    // pages too) -- see `lookup()`.
    _hasValidator() {
      const form = this.options.form || this.searchField.closest("form");
      return Boolean(form.data("validator"));
    },

    lookup() {
      const self = this;

      this.searchBlock.removeClass("with-results no-results fetch-error");

      // Only run jquery-validate when a validator has actually been initialised
      // on the form. jquery-validate is bundled on backoffice pages too, so
      // `$.fn.valid` alone isn't a safe signal: calling `.valid()` on a form
      // that was never `$(form).validate()`-d lazily creates a validator and
      // stamps `novalidate`, disabling native HTML5 validation. Smart-form
      // journeys initialise a validator (so behaviour is unchanged there); the
      // plain backoffice import forms never do, so this stays inert. Matches the
      // `direct_debit_form.coffee` pattern. Same guard applies in `fetch()`.
      if (
        !this.searchField.val().trim() ||
        (this._hasValidator() && !this.searchField.valid())
      ) {
        this.searchField.trigger("focus");
        return;
      }

      this.searchBlock.addClass("loading");

      $.ajax({
        type: "POST",
        url: this.options.lookupUrl,
        data: { postcode: this.searchField.val() },
        dataType: "json",
      })
        .done((data) => {
          self.showResults(data);
        })
        .fail(() => {
          // Treat failures as no results returned
          self.showResults([]);
        })
        .always(() => {
          self.searchBlock.removeClass("loading");
        });
    },

    showResults(results) {
      const self = this;

      // Clear existing options
      this.addressDropdown.find("option:gt(0)").remove();

      if (results.length > 0) {
        $(results).each((_, result) => {
          self.addressDropdown.append(
            `<option value="${result.id}">${result.description}</option>`,
          );
        });
        this.searchBlock.addClass("with-results");
        this.addressDropdown.trigger("focus");
      } else {
        this.searchBlock.addClass("no-results");
        this.searchField.trigger("focus");
      }
    },

    fetch(id) {
      const self = this;

      this.searchBlock.removeClass("fetch-error");
      this.searchBlock.addClass("loading");

      $.ajax({
        type: "POST",
        url: this.options.fetchUrl,
        data: { id },
        dataType: "json",
      })
        .done((data) => {
          self.populateAddress(data);
        })
        .fail(() => {
          self.addressDropdown.val("");

          // Surface the fetch failure through jquery-validate when the form has
          // a validator (smart-form journeys); otherwise (plain backoffice
          // import forms, where calling `.valid()` would lazily attach a
          // validator and disable native HTML5 validation) show the visible
          // `.fetch-error` alert. See `lookup()` for why plugin presence alone
          // isn't a safe signal.
          if (self._hasValidator()) {
            const storeMessage = self.addressDropdown.data("msg");
            self.addressDropdown.data(
              "msg",
              "We've found your address, but hit a system error. Please try again.",
            );
            self.addressDropdown.valid();
            self.addressDropdown.data("msg", storeMessage);
          } else {
            self.searchBlock.addClass("fetch-error");
          }
        })
        .always(() => {
          self.searchBlock.removeClass("loading");
        });
    },

    populateAddress(data) {
      this.addressFields.eq(0).changeVal(data.address_line_1);
      this.addressFields.eq(1).changeVal(data.address_line_2);
      this.addressFields.eq(2).changeVal(data.post_town);
      this.addressFields.eq(3).changeVal(data.postcode);

      // Dispatch a change event for the postcode field, so that listeners watching the form know the value changed
      this.addressFields
        .eq(3)[0]
        .dispatchEvent(new Event("change", { bubbles: true }));

      if (
        $(
          // eslint-disable-next-line max-len
          "#same_correspondence_address_pre_quote_yes, #same_correspondence_address_yes",
        ).is(":checked")
      ) {
        this.populateCorrespondenceAddress(data);
      }
      this.setState("manual");
    },

    populateCorrespondenceAddress(data) {
      $("#customer_address_1_pre_quote").changeVal(data.address_line_1);
      $("#customer_address_2_pre_quote").changeVal(data.address_line_2);
      $("#customer_town_pre_quote").changeVal(data.post_town);
      $("#customer_postcode_pre_quote").changeVal(data.postcode);
    },
  });
})(window.jQuery);
